const APPLIED_PIPELINE_SALES_REPS_KEY = 'sales-exp-applied-pipeline-sales-reps';

const setAppliedPipelineSalesReps = (salesReps: string[]): void => {
  if (typeof window === 'undefined' || salesReps.length === 0) {
    return;
  }
  sessionStorage.setItem(
    APPLIED_PIPELINE_SALES_REPS_KEY,
    JSON.stringify(salesReps),
  );
};

const getAppliedPipelineSalesReps = (): string[] | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const raw = sessionStorage.getItem(APPLIED_PIPELINE_SALES_REPS_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (
      Array.isArray(parsed) &&
      parsed.every((id) => typeof id === 'string' && id.length > 0)
    ) {
      return parsed;
    }
  } catch {
    sessionStorage.removeItem(APPLIED_PIPELINE_SALES_REPS_KEY);
  }
  return null;
};

const resolveReferralProspectsSalesReps = (
  contactId?: string,
): string[] | null => {
  const applied = getAppliedPipelineSalesReps();
  if (applied?.length) {
    return applied;
  }
  if (contactId) {
    return [contactId];
  }
  return null;
};

export {
  getAppliedPipelineSalesReps,
  resolveReferralProspectsSalesReps,
  setAppliedPipelineSalesReps,
};
